<!--
  - Copyright (c) 2024. Haodong JU
  -->

<template>
  <v-dialog
    ref="dialog"
    v-model="dialog"
    width="290px"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        v-model="internalValue"
        :dense="dense"
        :rules="rules"
        outlined
        prepend-inner-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="internalValue"
      :min="min"
      @input="dialog=false"
    />
  </v-dialog>
</template>

<script>
export default {
  name: 'DateSelector',
  props: {
    value: {},
    rules: {},
    dense: {},
    min: {}
  },
  data: function () {
    return {
      internalValue: null,
      dialog: false
    }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler: function () {
        this.internalValue = this.value
      }
    },
    internalValue () {
      this.$emit('input', this.internalValue)
    }
  }
}
</script>

<style scoped>

</style>
